import React from 'react'

import { B2CTypeTable } from '@/types.ts'
import { B2CStateFilter } from '@/pages/b2c/components/b2c-toggle-filter/b2c-state-filter.tsx'
import { B2CRegistryTableStateFilter } from '@/pages/b2c/components/b2c-toggle-filter/b2c-registry-table-state-filter.tsx'
import { useB2CState } from '@/stores/slices/b2c-slice'

export const B2CToggleFilter = (): React.ReactElement => {
  const { b2cType } = useB2CState()

  return b2cType !== B2CTypeTable.REGISTRIES ? <B2CStateFilter /> : <B2CRegistryTableStateFilter />
}
